import React from 'react';
import { motion } from 'framer-motion';
import { ActivityIcon, ZapIcon, DollarSignIcon, TimerIcon } from 'lucide-react';
import { SlideLayout, itemVariants } from '../ui/SlideLayout';
export function PerformanceSlide() {
  return <SlideLayout data-id="element-316" data-mp="qlexdsyg7rqx">
      <motion.div variants={itemVariants} className="mb-16 text-center" data-id="element-317" data-mp="qkvkiqnnntjr">
        <h2 className="text-4xl md:text-5xl font-bold text-brand-text mb-4" data-id="element-318" data-mp="lmtx5tj7582h">
          Faster and Cheaper —{' '}
          <span className="text-brand-text-muted" data-id="element-319" data-mp="1ib9rs415y7mg">Not a Tradeoff</span>
        </h2>
      </motion.div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12" data-id="element-320" data-mp="1eazjgkpwf54f">
        {/* KPI 1 */}
        <motion.div variants={itemVariants} className="bg-brand-bg-card border border-brand-border rounded-2xl p-8 relative overflow-hidden group hover:border-brand-teal/50 transition-colors" data-id="element-321" data-mp="199jzyx3dd6o5">
          <div className="absolute top-0 right-0 p-6 opacity-10 group-hover:opacity-20 transition-opacity" data-id="element-322" data-mp="3tz9f7b7ziuhd">
            <ActivityIcon className="w-24 h-24 text-brand-teal" data-id="element-323" data-mp="3p4lu7mc6wi7j" />
          </div>
          <div className="relative z-10" data-id="element-324" data-mp="19y5xogjtn836">
            <div className="text-5xl md:text-6xl font-bold text-brand-teal tracking-tighter mb-4" data-id="element-325" data-mp="1e2dnkh20mu2z">
              5k-10k
            </div>
            <h3 className="text-xl font-bold text-brand-text mb-2" data-id="element-326" data-mp="101krhrw2fqxr">
              Tokens / Second
            </h3>
            <p className="text-brand-text-dim" data-id="element-327" data-mp="14zcm4to3hr5n">
              Throughput target for Llama 8B. Potentially faster than most GPU
              endpoints for this model class.
            </p>
          </div>
        </motion.div>

        {/* KPI 2 */}
        <motion.div variants={itemVariants} className="bg-brand-bg-card border border-brand-border rounded-2xl p-8 relative overflow-hidden group hover:border-brand-teal/50 transition-colors" data-id="element-328" data-mp="hc4o8wszxkdn">
          <div className="absolute top-0 right-0 p-6 opacity-10 group-hover:opacity-20 transition-opacity" data-id="element-329" data-mp="7eq9d1mq13ng">
            <TimerIcon className="w-24 h-24 text-brand-teal" data-id="element-330" data-mp="cc07d5o6enmw" />
          </div>
          <div className="relative z-10" data-id="element-331" data-mp="3pecffyu4n0i5">
            <div className="text-5xl md:text-6xl font-bold text-brand-teal tracking-tighter mb-4" data-id="element-332" data-mp="3pfdsu9ym7z31">
              &lt;100<span className="text-3xl" data-id="element-333" data-mp="3kkq0u14ekmjp">ms</span>
            </div>
            <h3 className="text-xl font-bold text-brand-text mb-2" data-id="element-334" data-mp="3fnzl5ewifsyt">
              Time-to-First-Token
            </h3>
            <p className="text-brand-text-dim" data-id="element-335" data-mp="3ama7rsltf37k">
              Llama 70B latency reduced from ~300ms. The difference between
              fluid and broken for real-time apps.
            </p>
          </div>
        </motion.div>

        {/* KPI 3 */}
        <motion.div variants={itemVariants} className="bg-brand-bg-card border border-brand-border rounded-2xl p-8 relative overflow-hidden group hover:border-brand-teal/50 transition-colors" data-id="element-336" data-mp="27s6qauaknxg">
          <div className="absolute top-0 right-0 p-6 opacity-10 group-hover:opacity-20 transition-opacity" data-id="element-337" data-mp="2mzlkere1eijk">
            <ZapIcon className="w-24 h-24 text-brand-teal" data-id="element-338" data-mp="2hy61p5zc0o4c" />
          </div>
          <div className="relative z-10" data-id="element-339" data-mp="xiq2l3sxugvj">
            <div className="text-4xl md:text-5xl font-bold text-brand-teal tracking-tighter mb-4" data-id="element-340" data-mp="xfls5oovqowf">
              Near-Zero
            </div>
            <h3 className="text-xl font-bold text-brand-text mb-2" data-id="element-341" data-mp="17fclhn1pexux">
              Latency Jitter
            </h3>
            <p className="text-brand-text-dim" data-id="element-342" data-mp="1c7mj7p92927r">
              Deterministic FPGA execution eliminates variance spikes. Every
              request lands within a tight latency band.
            </p>
          </div>
        </motion.div>

        {/* KPI 4 */}
        <motion.div variants={itemVariants} className="bg-brand-bg-card border border-brand-border rounded-2xl p-8 relative overflow-hidden group hover:border-brand-teal/50 transition-colors" data-id="element-343" data-mp="1l93u8t7m2dpl">
          <div className="absolute top-0 right-0 p-6 opacity-10 group-hover:opacity-20 transition-opacity" data-id="element-344" data-mp="3ry8qob6ba5pb">
            <DollarSignIcon className="w-24 h-24 text-brand-teal" data-id="element-345" data-mp="qmhy44qjd1l" />
          </div>
          <div className="relative z-10" data-id="element-346" data-mp="1r89lzl6j5nxb">
            <div className="text-4xl md:text-5xl font-bold text-brand-teal tracking-tighter mb-4" data-id="element-347" data-mp="1r6yh1i1cma4m">
              Lowest $/M
            </div>
            <h3 className="text-xl font-bold text-brand-text mb-2" data-id="element-348" data-mp="2097pm2d23tfd">
              Cost per Token
            </h3>
            <p className="text-brand-text-dim" data-id="element-349" data-mp="1w7w0rz20bc88">
              Talk to us about how we can get you the lowest cost while
              exceeding your latency goals.
            </p>
          </div>
        </motion.div>
      </div>

      <motion.div variants={itemVariants} className="text-center max-w-3xl mx-auto" data-id="element-350" data-mp="13k03ot8iziax">
        <p className="text-brand-text-muted bg-brand-bg-card/50 py-3 px-6 rounded-full border border-brand-border inline-block" data-id="element-351" data-mp="1hb5808mu8yrl">
          <span className="text-brand-text font-medium" data-id="element-352" data-mp="1chiw4ioi0ywu">The Tradeoff:</span>{' '}
          Where throughput exceeds requirements, we parallelize to trade excess
          speed for even lower per-token cost.
        </p>
      </motion.div>
    </SlideLayout>;
}